import {Navigate} from 'react-router-dom';

import {appPaths} from '@/config/appPaths';

import SetPasswordForm from './SetPasswordForm';
import useSetPassword from './useSetPassword';

const SetPassword = () => {
  const {tokenResponse, isLoading, handleSubmit, handleChange} =
    useSetPassword();
  // Only reachable from the reset OTP, which brings the token with it.
  if (!tokenResponse) {
    return <Navigate to={`/${appPaths.forgotPassword}`} replace />;
  }
  return (
    <SetPasswordForm
      isLoading={isLoading}
      handleSubmit={handleSubmit}
      handleChange={handleChange}
    />
  );
};

export default SetPassword;
